import { HttpRequest } from '@angular/common/http';

export function setHeader<T>(request: HttpRequest<T>, headerName: string, headerValue?: string): HttpRequest<T> {
    if (headerValue) {
        const setHeaders: Record<string, string> = {};
        setHeaders[headerName] = headerValue;
        return request.clone({ setHeaders });
    }
    return request;
}
